import { render } from "./TubeCatalogueAdminView.vue?vue&type=template&id=0d31a947&scoped=true"
import script from "./TubeCatalogueAdminView.vue?vue&type=script&lang=js"
export * from "./TubeCatalogueAdminView.vue?vue&type=script&lang=js"

import "./TubeCatalogueAdminView.vue?vue&type=style&index=0&id=0d31a947&scoped=true&lang=css"

import exportComponent from "D:\\Cotizador Frontend\\dyc_cotizador_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d31a947"]])

export default __exports__